import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import {
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow,
    Typography, Switch, TextField, Card, Chip, Dialog, DialogTitle,
    DialogContent, DialogActions, Pagination, IconButton, Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { useLocation, useNavigate } from "react-router-dom";
import BlockchainAdminNav from "../../components/blockchain-admin-nav";
import BlockchainAutoControl from "../../components/blockchain-auto-control";
import BlockchainBetPressure from "../../components/blockchain-bet-pressure";
import BlockchainAdminActions from "../../components/blockchain-admin-actions";
import BlockchainClassicSummary from "../../components/blockchain-classic-summary";
import BlockchainGameGuideModal from "../../components/BlockchainGameGuideModal";

function SetBaccarat60s() {
    const blockchainApi = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;

    const [list30, setList30] = useState([]);
    const [bet, setBet] = useState(null);
    const [second, setSecond] = useState(0);
    const [dulieunhap, setDulieunhap] = useState(null);
    const [current, setCurrent] = useState([]);
    const [tableConfig, setTableConfig] = useState({
        enabled: true,
        durationSeconds: 60,
        minBet: 10,
        maxBet: 1000000,
        code: `50-${["A", "B", "C", "D", "E", "F"][SANH_ID - 1]}`
    });
    const [savingTable, setSavingTable] = useState(false);
    const [selectedResults, setSelectedResults] = useState({});

    // Table pagination state
    const [tablePage, setTablePage] = useState(1);
    const rowsPerPage = 10;

    // 3 Modals
    const [openTileModal, setOpenTileModal] = useState(false);
    const [openLichSuPhienModal, setOpenLichSuPhienModal] = useState(false);
    const [openLichSuDatCuocModal, setOpenLichSuDatCuocModal] = useState(false);
    const [openGuideModal, setOpenGuideModal] = useState(false);

    // Search & Filter states
    const [searchPhien, setSearchPhien] = useState("");
    const [searchUser, setSearchUser] = useState("");
    const [searchDate, setSearchDate] = useState("");
    const [lichSuPhienList, setLichSuPhienList] = useState([]);
    const [lichSuPhienPage, setLichSuPhienPage] = useState(1);
    const [lichSuDatCuocList, setLichSuDatCuocList] = useState([]);
    const [lichSuDatCuocPage, setLichSuDatCuocPage] = useState(1);

    const fetchHistoryPhienModal = () => {
        axios.get(`${blockchainApi}/baccarat60s/getHistoryBet?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setLichSuPhienList(res.data.data);
                }
            })
            .catch(() => { });
    };

    const fetchRealBetHistory = () => {
        axios.get(`${blockchainApi}/baccarat60s/getAllBetByAdmin?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setLichSuDatCuocList(res.data.data);
                }
            })
            .catch(() => { });
    };

    // Tỉ lệ trả thưởng states (44 ô cấu hình Baccarat)
    const [rates, setRates] = useState({
        con: 1, caiAnDu: 1, caiCoDien: 0.95, hoa: 8,
        conChuan: 4, caiChuan: 4, conLe: 0.96, conChan: 0.9,
        caiLe: 0.94, caiChan: 0.94, tai: 0.54, xiu: 1.5,
        conLongBao9: 30, conLongBao8: 10, conLongBao7: 5, conLongBao6: 3,
        conLongBao5: 2, conLongBao4: 1, conLongBaoChuanThang: 1, conLongBaoChuanHoa: 0,
        caiLongBao9: 30, caiLongBao8: 10, caiLongBao7: 5, caiLongBao6: 3,
        caiLongBao5: 2, caiLongBao4: 1, caiLongBaoChuanThang: 1, caiLongBaoChuanHoa: 0,
        caiDoi: 11, conDoi: 11, doiBatKy: 5, doiHoanMy: 25,
        hoa9: 80, hoa8: 80, hoa7: 45, hoa6: 45,
        hoa5: 110, hoa4: 120, hoa3: 200, hoa2: 225, hoa1: 215, hoa0: 150,
        super6_2la: 12, super6_3la: 20
    });

    const handleRateChange = (field, value) => {
        setRates(prev => ({ ...prev, [field]: value }));
    };

    useEffect(() => {
        const interceptor = axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("user");
                if (token) config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            },
            (error) => Promise.reject(error)
        );
        return () => axios.interceptors.request.eject(interceptor);
    }, []);

    const reloadHistorySilently = () => {
        axios.get(`${blockchainApi}/baccarat60s/list30bet?sanh=${SANH_ID}`).then((res) => {
            setList30(res.data.data || []);
        }).catch(() => setList30([]));
    };

    const fetchCurrentBets = () => {
        axios.get(`${blockchainApi}/baccarat60s/getcurrent?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                setCurrent(res.data.data);
            } else {
                setCurrent([]);
            }
        }).catch(() => setCurrent([]));
    };

    const fetchNewSessionAdmin = () => {
        axios.get(`${blockchainApi}/baccarat60s/get?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                const data = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                if (data) {
                    setBet(data);
                    if (data.createdAt) setDulieunhap(new Date(data.createdAt));
                }
            }
        }).catch(() => { });

        reloadHistorySilently();
        fetchCurrentBets();
    };

    const fetchTableConfig = () => {
        axios.get(`${blockchainApi}/baccarat60s/tables`).then((res) => {
            const tables = res.data?.data || [];
            const selected = tables.find((item) => Number(item.sanh) === SANH_ID);
            if (!selected) return;
            setTableConfig(selected);
            if (selected.odds) setRates((previous) => ({ ...previous, ...selected.odds }));
        }).catch(() => { });
    };

    const saveTableConfig = (includeRates = false) => {
        const minBet = Number(tableConfig.minBet);
        const maxBet = Number(tableConfig.maxBet);
        if (!Number.isFinite(minBet) || !Number.isFinite(maxBet) || minBet <= 0 || maxBet < minBet) {
            swal("Lỗi", "Giới hạn cược không hợp lệ.", "error");
            return;
        }
        setSavingTable(true);
        axios.put(`${blockchainApi}/baccarat60s/table/${SANH_ID}`, {
            enabled: Boolean(tableConfig.enabled),
            minBet,
            maxBet,
            ...(includeRates ? { odds: rates } : {})
        }).then((res) => {
            if (res.data?.data) setTableConfig(res.data.data);
            swal("Thành công", includeRates ? "Đã lưu tỉ lệ riêng cho bàn 60s." : "Đã cập nhật cấu hình bàn.", "success");
            if (includeRates) setOpenTileModal(false);
            fetchTableConfig();
        }).catch((error) => {
            swal("Lỗi", error.response?.data?.message || "Không thể cập nhật cấu hình bàn.", "error");
        }).finally(() => setSavingTable(false));
    };

    useEffect(() => {
        setBet(null);
        setCurrent([]);
        fetchNewSessionAdmin();
        fetchRealBetHistory();
        fetchTableConfig();
    }, [SANH_ID]);

    useEffect(() => {
        const liveRefresh = setInterval(() => {
            fetchCurrentBets();
            if (openLichSuDatCuocModal) fetchRealBetHistory();
            if (openLichSuPhienModal) fetchHistoryPhienModal();
        }, 2000);
        return () => clearInterval(liveRefresh);
    }, [SANH_ID, openLichSuDatCuocModal, openLichSuPhienModal]);

    useEffect(() => {
        if (!dulieunhap || isNaN(dulieunhap.getTime())) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diffInSeconds = Math.floor((now.getTime() - dulieunhap.getTime()) / 1000);
            const remaining = 60 - diffInSeconds;
            if (remaining < 0) {
                setSecond(0);
                fetchNewSessionAdmin();
            } else {
                setSecond(remaining);
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);

    const handleSelectRowResult = (rowId, result) => {
        setSelectedResults(prev => ({ ...prev, [rowId]: result }));
    };

    const handleUpdateRowResult = (row) => {
        const sourceResult = String(selectedResults[row._id] || row.resultCode || row.result || "P").toUpperCase();
        const resultString = sourceResult.startsWith("B") ? "B" : sourceResult.startsWith("T") ? "Tie" : "P";
        const formData = { id_bet: row._id, result: resultString, sanh: SANH_ID };
        axios.post(`${blockchainApi}/baccarat60s/update`, formData)
            .then((response) => {
                swal("Thành công", response?.data?.message || `Đã cập nhật kết quả Baccarat 60s phiên #${row.id_bet}: ${resultString === 'P' ? 'Player' : resultString === 'B' ? 'Banker' : 'Tie'}`, "success");
                reloadHistorySilently();
            })
            .catch((error) => swal("Lỗi", error.response?.data?.message || "Có lỗi xảy ra khi cài đặt kết quả!", "error"));
    };

    const sanhLetters = ["A", "B", "C", "D", "E", "F"];
    const formatMoney = (n) => String(n ? Math.floor(n / 1000) : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const filteredLichSuPhien = (lichSuPhienList || []).filter(item =>
        String(item.id_bet || item._id).toLowerCase().includes((searchPhien || "").toLowerCase())
    );

    const formatDateYYYYMMDD = (d) => {
        if (!d) return "";
        const dateObj = new Date(d);
        if (isNaN(dateObj.getTime())) return "";
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const day = String(dateObj.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const filteredLichSuDatCuoc = (lichSuDatCuocList || []).filter(item => {
        const username = item.user?.username || item.user?.name || "";
        const matchUser = !searchUser || username.toLowerCase().includes(searchUser.toLowerCase().trim());
        let matchDate = true;
        if (searchDate) {
            const itemDate = formatDateYYYYMMDD(item.createdAt);
            matchDate = itemDate === searchDate;
        }
        return matchUser && matchDate;
    });

    const totalBetMoney = filteredLichSuDatCuoc.reduce((acc, curr) => acc + (Number(curr.money) || 0), 0);
    const totalWinMoney = filteredLichSuDatCuoc.reduce((acc, curr) => acc + (Number(curr.moneythang || curr.winMoney) || 0), 0);

    const renderResultChip = (resStr) => {
        if (!resStr || resStr === "") return <Chip label="Chưa xổ" sx={{ background: "#94a3b8", color: "#fff", fontWeight: 600, borderRadius: "16px", height: "26px" }} />;
        const normalized = String(resStr).toUpperCase();
        if (normalized === "P" || normalized === "PLAYER" || normalized === "CON" || normalized.startsWith("P:")) return <Chip label="Player" sx={{ background: "#1d4ed8", color: "#fff", fontWeight: 600, borderRadius: "16px", height: "26px" }} />;
        if (normalized === "B" || normalized === "BANKER" || normalized === "CAI" || normalized.startsWith("B:")) return <Chip label="Banker" sx={{ background: "#dc2626", color: "#fff", fontWeight: 600, borderRadius: "16px", height: "26px" }} />;
        if (normalized === "T" || normalized === "TIE" || normalized === "HOA" || normalized.startsWith("T:")) return <Chip label="Tie" sx={{ background: "#10b981", color: "#fff", fontWeight: 600, borderRadius: "16px", height: "26px" }} />;
        return <Chip label={resStr} sx={{ background: "#94a3b8", color: "#fff", fontWeight: 600, borderRadius: "16px", height: "26px" }} />;
    };

    const getPoints = (row, resultStr) => {
        if (row.pointsPlayer !== undefined && row.pointsBanker !== undefined && (row.pointsPlayer > 0 || row.pointsBanker > 0)) {
            return { player: row.pointsPlayer, banker: row.pointsBanker };
        }
        if (!resultStr) return { player: "—", banker: "—" };
        if (resultStr === "B") return { player: 0, banker: 6 };
        if (resultStr === "P") return { player: 8, banker: 3 };
        return { player: 7, banker: 7 };
    };

    const activeRoundResult = (() => {
        if (!bet) return "P";
        const value = String(selectedResults[bet._id] || bet.resultCode || bet.result || "P").toUpperCase();
        if (value === "B" || value === "BANKER" || value.startsWith("B:")) return "B";
        if (value === "T" || value === "TIE" || value === "HOA" || value.startsWith("T:")) return "Tie";
        return "P";
    })();
    const canEditActiveRound = Boolean(bet?._id && second > Number(tableConfig.bettingClosesAt || 5) && !bet.settledAt);

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" className="blockchain-admin-page happy-classic-game happy-classic-baccarat" sx={{ flexGrow: 1, py: 3, px: 2, background: "#f4f6f8", minHeight: "100vh" }}>
                    <Container maxWidth="xl">

                        <div className="classic-game-guide"><button onClick={() => setOpenGuideModal(true)}>Hướng dẫn <span>?</span></button></div>
                        {/* Thanh chọn sảnh gọn gàng */}
                        <Box className="classic-game-room-tabs" sx={{ mb: 2.5, display: "flex", alignItems: "center", gap: 1, p: 1, bgcolor: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "12px" }}>
                            <Typography sx={{ fontSize: 13, color: "#64748b", fontWeight: 400, mr: 1, ml: 1 }}>Chọn bàn:</Typography>
                            {["A", "B", "C", "D", "E", "F"].map((letter, idx) => {
                                const id = idx + 1;
                                const isActive = id === SANH_ID;
                                return (
                                    <Button
                                        key={letter}
                                        size="small"
                                        variant={isActive ? "contained" : "outlined"}
                                        onClick={() => navigate(`?sanh=${id}`)}
                                        sx={{
                                            borderRadius: "8px",
                                            fontWeight: isActive ? 600 : 400,
                                            fontSize: "13px",
                                            textTransform: "none",
                                            bgcolor: isActive ? "#2563eb !important" : "#ffffff !important",
                                            color: isActive ? "#ffffff !important" : "#334155 !important",
                                            borderColor: isActive ? "#2563eb !important" : "#cbd5e1 !important",
                                            boxShadow: isActive ? "0 2px 4px rgba(37,99,235,0.2)" : "none",
                                            minWidth: "70px",
                                            "&:hover": {
                                                bgcolor: isActive ? "#1d4ed8 !important" : "#f8fafc !important",
                                                borderColor: isActive ? "#1d4ed8 !important" : "#94a3b8 !important"
                                            }
                                        }}
                                    >
                                        Baccarat 60 giây Bàn {letter}
                                    </Button>
                                );
                            })}
                        </Box>

                        <BlockchainAdminActions configLabel="Tỉ lệ & cấu hình" onConfig={() => setOpenTileModal(true)} onRoundHistory={() => { fetchHistoryPhienModal(); setOpenLichSuPhienModal(true); }} onBetHistory={() => { fetchRealBetHistory(); setOpenLichSuDatCuocModal(true); }} />

                        <BlockchainAutoControl game="baccarat" />

                        <Card className="classic-table-config" sx={{ mb: 3, p: 2.5, borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0,0,0,0.04)" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap" }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography fontWeight={400} fontSize="14px" color="#334155">Hoạt động bàn {sanhLetters[SANH_ID - 1]}</Typography>
                                    <Switch
                                        checked={Boolean(tableConfig.enabled)}
                                        onChange={(e) => setTableConfig((previous) => ({ ...previous, enabled: e.target.checked }))}
                                        color="primary"
                                    />
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography fontWeight={400} fontSize="14px" color="#334155">Cược tối thiểu</Typography>
                                    <TextField
                                        size="small"
                                        type="number"
                                        value={tableConfig.minBet}
                                        onChange={(e) => setTableConfig((previous) => ({ ...previous, minBet: e.target.value }))}
                                        sx={{ width: 130, bg: "#fff" }}
                                    />
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography fontWeight={400} fontSize="14px" color="#334155">Cược tối đa</Typography>
                                    <TextField
                                        size="small"
                                        type="number"
                                        value={tableConfig.maxBet}
                                        onChange={(e) => setTableConfig((previous) => ({ ...previous, maxBet: e.target.value }))}
                                        sx={{ width: 150, bg: "#fff" }}
                                    />
                                </Box>
                                <Chip label={`${tableConfig.code || `50-${sanhLetters[SANH_ID - 1]}`} · 60 giây`} color="primary" variant="outlined" sx={{ fontWeight: 400, borderRadius: "8px" }} />
                                <Button
                                    variant="contained"
                                    disabled={savingTable}
                                    sx={{ background: "#10b981", "&:hover": { background: "#059669" }, textTransform: "none", borderRadius: "8px", fontWeight: 400 }}
                                    onClick={() => saveTableConfig(false)}
                                >
                                    {savingTable ? "Đang lưu..." : "Lưu cấu hình bàn"}
                                </Button>
                            </Box>
                            <Typography sx={{ mt: 1.5, color: "#64748b", fontSize: "13px", fontWeight: 300 }}>
                                Chế độ demo cho phép chọn kết quả phiên đang chạy. Hệ thống khóa cập nhật khi còn {tableConfig.bettingClosesAt || 5} giây và bắt đầu chia bài; mọi thao tác đều lưu nhật ký quản trị.
                            </Typography>
                        </Card>

                        <Card className="classic-round-banner" sx={{ mb: 3, textAlign: "center", py: 2.5, background: "#ffffff", borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 400, color: "#1e293b", mb: 0.5, fontSize: "17px" }}>
                                Kỳ sổ: <span style={{ color: "#2563eb", fontWeight: 500 }}>{bet ? (bet.id_bet || bet._id) : "Đang tải..."}</span>
                            </Typography>
                            <Typography variant="body1" sx={{ color: "#475569", fontWeight: 400 }}>
                                Thời gian: <strong style={{ color: "#2563eb", fontSize: "20px", fontWeight: 500 }}>00:{second < 10 ? `0${second}` : second}</strong>
                            </Typography>
                        </Card>

                        <Card className="classic-active-editor" sx={{ p: { xs: 1.5, sm: 2.5 }, mb: 3, borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0,0,0,0.04)" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: 1.5, mb: 2 }}>
                                <Box><Typography variant="h6" sx={{ fontWeight: 500, fontSize: { xs: 16, sm: 17 } }}>Chỉnh kết quả bàn {sanhLetters[SANH_ID - 1]}</Typography><Typography sx={{ color: "#64748b", fontSize: 13, fontWeight: 300 }}>Phiên #{bet?.id_bet || "Đang tải"} · còn {second}s</Typography></Box>
                                <Chip size="small" color={canEditActiveRound ? "success" : "warning"} label={canEditActiveRound ? "Có thể chỉnh" : "Kết quả đã khóa"} sx={{ fontWeight: 400, borderRadius: "6px" }} />
                            </Box>
                            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(3,1fr)", sm: "repeat(3,minmax(120px,170px))" }, gap: 1 }}>
                                {[["P", "Player", "#2563eb"], ["B", "Banker", "#dc2626"], ["Tie", "Tie", "#059669"]].map(([value, label, color]) => <Button key={value} disabled={!canEditActiveRound} variant={activeRoundResult === value ? "contained" : "outlined"} onClick={() => handleSelectRowResult(bet._id, value)} sx={{ minWidth: 0, height: 42, borderRadius: "8px", fontWeight: 400, textTransform: "none", bgcolor: activeRoundResult === value ? color : "#fff", borderColor: color, color: activeRoundResult === value ? "#fff" : color, "&:hover": { bgcolor: activeRoundResult === value ? color : `${color}0d`, borderColor: color } }}>{label}</Button>)}
                            </Box>
                            <Button fullWidth variant="contained" color="warning" disabled={!canEditActiveRound} onClick={() => handleUpdateRowResult(bet)} sx={{ mt: 1.5, height: 42, borderRadius: "8px", fontWeight: 400, textTransform: "none" }}>Lưu kết quả phiên hiện tại</Button>
                        </Card>


                        <BlockchainClassicSummary game="baccarat" bets={current} />

                        <Card className="classic-current-bets-hidden" sx={{ p: 2, mb: 3, borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)", overflowX: "auto" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: "#1e293b", fontSize: "16px" }}>Danh Sách Người Chơi Đặt Cược Phiên Hiện Tại</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Người chơi</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Cửa đặt</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Tiền cược</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Thời gian</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {current && current.length > 0 ? (
                                        current.map((item, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell sx={{ fontWeight: 500, color: "#1d4ed8" }}>{item.user?.username || item.user?.name || "Người chơi"}</TableCell>
                                                <TableCell><Chip label={item.state || "Player"} color="primary" size="small" /></TableCell>
                                                <TableCell sx={{ fontWeight: 500, color: "#d97706" }}>{formatMoney(item.money)}</TableCell>
                                                <TableCell>{new Date(item.createdAt).toLocaleTimeString()}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center" sx={{ py: 3, color: "#64748b", fontWeight: 400 }}>
                                                Chưa có người chơi nào đặt cược ở phiên này.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Card>

                        <Card className="classic-result-table" sx={{ p: 2, borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, color: "#1e293b", fontSize: "16px" }}>Chỉnh Kết Quả Phiên Đang Chạy (Demo)</Typography>
                            <Typography sx={{ mb: 2, color: "#64748b", fontSize: "13px" }}>Chọn Player, Banker hoặc Tie ở dòng phiên hiện tại. Bộ bài được sinh theo đúng luật Baccarat và FE chỉ mở khi tới giai đoạn chia bài.</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>PHIÊN</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>ĐIỂM NGƯỜI CHƠI</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>ĐIỂM NHÀ CÁI</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>KẾT QUẢ</TableCell>
                                        <TableCell sx={{ fontWeight: 600, textAlign: "center", color: "#475569" }}>CẬP NHẬT</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {list30.slice((tablePage - 1) * rowsPerPage, tablePage * rowsPerPage).map((row) => {
                                        const isCurrentRound = String(row._id) === String(bet?._id);
                                        const isSettled = Boolean(row.settledAt);
                                        const canPreset = !isSettled;
                                        let currentSel = selectedResults[row._id];
                                        if (!currentSel) {
                                            const p = Number(row.pointsPlayer);
                                            const b = Number(row.pointsBanker);
                                            if (row.pointsPlayer !== undefined && row.pointsBanker !== undefined && !isNaN(p) && !isNaN(b)) {
                                                if (p > b) currentSel = "P";
                                                else if (b > p) currentSel = "B";
                                                else currentSel = "Tie";
                                            }
                                            if (!currentSel && row.result) {
                                                const r = String(row.result).toUpperCase();
                                                if (r === "B" || r === "BANKER" || r.startsWith("B:")) currentSel = "B";
                                                else if (r === "T" || r === "TIE" || r === "HOA" || r.startsWith("T:")) currentSel = "Tie";
                                                else if (r === "P" || r === "PLAYER" || r.startsWith("P:")) currentSel = "P";
                                            }
                                            // Không mặc định - để null nếu chưa có kết quả
                                        }
                                        const pts = getPoints(row, currentSel);
                                        return (
                                            <TableRow key={row._id} hover sx={{ bgcolor: isCurrentRound ? "#eff6ff" : isSettled ? "#f9fafb" : undefined }}>
                                                <TableCell sx={{ fontWeight: 500 }}>
                                                    {row.id_bet}
                                                    {isCurrentRound && <Chip size="small" label="Đang chạy" color="primary" sx={{ ml: 1 }} />}
                                                    {!isCurrentRound && isSettled && <Chip size="small" label="Đã khóa" sx={{ ml: 1, bgcolor: "#94a3b8", color: "#fff" }} />}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600, color: "#1d4ed8" }}>{pts.player}</TableCell>
                                                <TableCell sx={{ fontWeight: 600, color: "#dc2626" }}>{pts.banker}</TableCell>
                                                <TableCell>{renderResultChip(currentSel)}</TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    {isSettled && !isCurrentRound ? (
                                                        <Chip size="small" label="Đã khóa" sx={{ bgcolor: "#e2e8f0", color: "#64748b", fontWeight: 500 }} />
                                                    ) : (
                                                        <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                                                            <Button
                                                                size="small"
                                                                variant={currentSel === 'P' ? 'contained' : 'outlined'}
                                                                color="primary"
                                                                sx={{
                                                                    textTransform: "none",
                                                                    borderRadius: "8px",
                                                                    minWidth: 70,
                                                                    fontWeight: currentSel === 'P' ? 700 : 400,
                                                                    bgcolor: currentSel === 'P' ? "#2563eb !important" : "#ffffff !important",
                                                                    color: currentSel === 'P' ? "#ffffff !important" : "#2563eb !important",
                                                                    border: "1.5px solid #2563eb !important"
                                                                }}
                                                                disabled={!canPreset}
                                                                onClick={() => handleSelectRowResult(row._id, 'P')}
                                                            >
                                                                Player
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                variant={currentSel === 'B' ? 'contained' : 'outlined'}
                                                                color="error"
                                                                sx={{
                                                                    textTransform: "none",
                                                                    borderRadius: "8px",
                                                                    minWidth: 70,
                                                                    fontWeight: currentSel === 'B' ? 700 : 400,
                                                                    bgcolor: currentSel === 'B' ? "#dc2626 !important" : "#ffffff !important",
                                                                    color: currentSel === 'B' ? "#ffffff !important" : "#dc2626 !important",
                                                                    border: "1.5px solid #dc2626 !important"
                                                                }}
                                                                disabled={!canPreset}
                                                                onClick={() => handleSelectRowResult(row._id, 'B')}
                                                            >
                                                                Banker
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                variant={(currentSel === 'T' || currentSel === 'Tie') ? 'contained' : 'outlined'}
                                                                color="success"
                                                                sx={{
                                                                    textTransform: "none",
                                                                    borderRadius: "8px",
                                                                    minWidth: 70,
                                                                    fontWeight: (currentSel === 'T' || currentSel === 'Tie') ? 700 : 400,
                                                                    bgcolor: (currentSel === 'T' || currentSel === 'Tie') ? "#059669 !important" : "#ffffff !important",
                                                                    color: (currentSel === 'T' || currentSel === 'Tie') ? "#ffffff !important" : "#059669 !important",
                                                                    border: "1.5px solid #059669 !important"
                                                                }}
                                                                disabled={!canPreset}
                                                                onClick={() => handleSelectRowResult(row._id, 'Tie')}
                                                            >
                                                                Tie
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                variant="contained"
                                                                disabled={!canPreset}
                                                                sx={{
                                                                    bgcolor: '#ef4444 !important',
                                                                    color: '#ffffff !important',
                                                                    '&:hover': { bgcolor: '#dc2626 !important' },
                                                                    fontWeight: 600,
                                                                    textTransform: "none",
                                                                    borderRadius: "8px",
                                                                    px: 2.5
                                                                }}
                                                                onClick={() => handleUpdateRowResult(row)}
                                                            >
                                                                {isCurrentRound ? "Cập nhật" : "Cài trước"}
                                                            </Button>
                                                        </Box>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                <Pagination
                                    count={Math.ceil(list30.length / rowsPerPage) || 1}
                                    page={tablePage}
                                    onChange={(e, p) => setTablePage(p)}
                                    color="primary"
                                    size="small"
                                />
                            </Box>
                        </Card>
                    </Container>

                    <Dialog className="blockchain-data-dialog" open={openTileModal} onClose={() => setOpenTileModal(false)} maxWidth="md" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Cấu hình Tỉ Lệ Trả Thưởng Baccarat</Typography>
                            <IconButton onClick={() => setOpenTileModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                {[
                                    { key: "con", label: "Tỉ lệ trả thưởng [ Con ]" },
                                    { key: "caiAnDu", label: "Tỉ lệ trả thưởng [ Cái ăn đủ ]" },
                                    { key: "caiCoDien", label: "Tỉ lệ trả thưởng [ Cái cổ điển ]" },
                                    { key: "hoa", label: "Tỉ lệ trả thưởng [ Hòa ]" },
                                    { key: "conChuan", label: "Tỉ lệ trả thưởng [ Con chuẩn ]" },
                                    { key: "caiChuan", label: "Tỉ lệ trả thưởng [ Cái chuẩn ]" },
                                    { key: "conLe", label: "Tỉ lệ trả thưởng [ Con lẻ ]" },
                                    { key: "conChan", label: "Tỉ lệ trả thưởng [ Con chẵn ]" },
                                    { key: "caiLe", label: "Tỉ lệ trả thưởng [ Cái lẻ ]" },
                                    { key: "caiChan", label: "Tỉ lệ trả thưởng [ Cái chẵn ]" },
                                    { key: "tai", label: "Tỉ lệ trả thưởng [ Tài ]" },
                                    { key: "xiu", label: "Tỉ lệ trả thưởng [ Xỉu ]" },
                                    { key: "conLongBao9", label: "Tỉ lệ trả thưởng [ Con long bảo 9 ]" },
                                    { key: "conLongBao8", label: "Tỉ lệ trả thưởng [ Con long bảo 8 ]" },
                                    { key: "conLongBao7", label: "Tỉ lệ trả thưởng [ Con long bảo 7 ]" },
                                    { key: "conLongBao6", label: "Tỉ lệ trả thưởng [ Con long bảo 6 ]" },
                                    { key: "conLongBao5", label: "Tỉ lệ trả thưởng [ Con long bảo 5 ]" },
                                    { key: "conLongBao4", label: "Tỉ lệ trả thưởng [ Con long bảo 4 ]" },
                                    { key: "conLongBaoChuanThang", label: "Tỉ lệ trả thưởng [ Con long bảo chuẩn thắng ]" },
                                    { key: "conLongBaoChuanHoa", label: "Tỉ lệ trả thưởng [ Con long bảo chuẩn hòa ]" },
                                    { key: "caiLongBao9", label: "Tỉ lệ trả thưởng [ Cái long bảo 9 ]" },
                                    { key: "caiLongBao8", label: "Tỉ lệ trả thưởng [ Cái long bảo 8 ]" },
                                    { key: "caiLongBao7", label: "Tỉ lệ trả thưởng [ Cái long bảo 7 ]" },
                                    { key: "caiLongBao6", label: "Tỉ lệ trả thưởng [ Cái long bảo 6 ]" },
                                    { key: "caiLongBao5", label: "Tỉ lệ trả thưởng [ Cái long bảo 5 ]" },
                                    { key: "caiLongBao4", label: "Tỉ lệ trả thưởng [ Cái long bảo 4 ]" },
                                    { key: "caiLongBaoChuanThang", label: "Tỉ lệ trả thưởng [ Cái long bảo chuẩn thắng ]" },
                                    { key: "caiLongBaoChuanHoa", label: "Tỉ lệ trả thưởng [ Cái long bảo chuẩn hòa ]" },
                                    { key: "caiDoi", label: "Tỉ lệ trả thưởng [ Cái đôi ]" },
                                    { key: "conDoi", label: "Tỉ lệ trả thưởng [ Con đôi ]" },
                                    { key: "doiBatKy", label: "Tỉ lệ trả thưởng [ Đôi bất kỳ ]" },
                                    { key: "doiHoanMy", label: "Tỉ lệ trả thưởng [ Đôi hoàn mỹ ]" },
                                    { key: "hoa9", label: "Tỉ lệ trả thưởng [ Hòa 9 ]" },
                                    { key: "hoa8", label: "Tỉ lệ trả thưởng [ Hòa 8 ]" },
                                    { key: "hoa7", label: "Tỉ lệ trả thưởng [ Hòa 7 ]" },
                                    { key: "hoa6", label: "Tỉ lệ trả thưởng [ Hòa 6 ]" },
                                    { key: "hoa5", label: "Tỉ lệ trả thưởng [ Hòa 5 ]" },
                                    { key: "hoa4", label: "Tỉ lệ trả thưởng [ Hòa 4 ]" },
                                    { key: "hoa3", label: "Tỉ lệ trả thưởng [ Hòa 3 ]" },
                                    { key: "hoa2", label: "Tỉ lệ trả thưởng [ Hòa 2 ]" },
                                    { key: "hoa1", label: "Tỉ lệ trả thưởng [ Hòa 1 ]" },
                                    { key: "hoa0", label: "Tỉ lệ trả thưởng [ Hòa 0 ]" },
                                    { key: "super6_2la", label: "Tỉ lệ trả thưởng [ Super 6 2 lá ]" },
                                    { key: "super6_3la", label: "Tỉ lệ trả thưởng [ Super 6 3 lá ]" }
                                ].map((item) => (
                                    <Grid item xs={12} sm={4} key={item.key}>
                                        <Typography variant="body2" sx={{ mb: 0.5, color: "#334155", fontWeight: 500 }}>{item.label}</Typography>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            value={rates[item.key]}
                                            onChange={(e) => handleRateChange(item.key, e.target.value)}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </DialogContent>
                        <DialogActions sx={{ p: 2 }}>
                            <Button onClick={() => setOpenTileModal(false)} variant="outlined" sx={{ textTransform: "none", borderRadius: "8px" }}>Hủy bỏ</Button>
                            <Button onClick={() => saveTableConfig(true)} disabled={savingTable} variant="contained" color="primary" sx={{ textTransform: "none", borderRadius: "8px" }}>
                                {savingTable ? "Đang lưu..." : "Cập nhật"}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog className="blockchain-data-dialog" open={openLichSuPhienModal} onClose={() => setOpenLichSuPhienModal(false)} maxWidth="md" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Lịch sử phiên Baccarat</Typography>
                            <IconButton onClick={() => setOpenLichSuPhienModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                                <TextField size="small" placeholder="Phiên" value={searchPhien} onChange={(e) => setSearchPhien(e.target.value)} sx={{ flexGrow: 1 }} />
                                <Button variant="contained" sx={{ textTransform: "none", borderRadius: "8px", px: 3, background: "#2563eb" }}>Tìm kiếm</Button>
                            </Box>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600 }}>Phiên</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Kết quả</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Tổng cược</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Tổng trả</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Ngày tạo</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredLichSuPhien.length > 0 ? (
                                        filteredLichSuPhien.slice((lichSuPhienPage - 1) * 10, lichSuPhienPage * 10).map((row) => (
                                            <TableRow key={row._id} hover>
                                                <TableCell sx={{ fontWeight: 500 }}>{row.id_bet}</TableCell>
                                                <TableCell>{renderResultChip(row.result)}</TableCell>
                                                <TableCell style={{ color: "#10b981", fontWeight: 500 }}>{formatMoney(row.totalBet || 0)}</TableCell>
                                                <TableCell style={{ color: "#ef4444", fontWeight: 500 }}>{formatMoney(row.totalPay || 0)}</TableCell>
                                                <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString("vi-VN") : ""}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center" sx={{ py: 3, color: "#64748b" }}>
                                                Chưa có lịch sử phiên nào đã xổ.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                <Pagination count={Math.ceil(filteredLichSuPhien.length / 10) || 1} page={lichSuPhienPage} onChange={(e, p) => setLichSuPhienPage(p)} color="primary" />
                            </Box>
                        </DialogContent>
                    </Dialog>

                    <Dialog className="blockchain-data-dialog" open={openLichSuDatCuocModal} onClose={() => setOpenLichSuDatCuocModal(false)} maxWidth="lg" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Lịch sử đặt cược Baccarat</Typography>
                            <IconButton onClick={() => setOpenLichSuDatCuocModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
                                <TextField
                                    size="small"
                                    type="date"
                                    label="Khoảng thời gian"
                                    value={searchDate}
                                    onChange={(e) => { setSearchDate(e.target.value); setLichSuDatCuocPage(1); }}
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ width: 220 }}
                                />
                                <TextField
                                    size="small"
                                    placeholder="Tên người chơi"
                                    value={searchUser}
                                    onChange={(e) => { setSearchUser(e.target.value); setLichSuDatCuocPage(1); }}
                                    sx={{ flexGrow: 1 }}
                                />
                                <Button
                                    variant="contained"
                                    onClick={() => setLichSuDatCuocPage(1)}
                                    sx={{ textTransform: "none", borderRadius: "8px", px: 4, background: "#2563eb" }}
                                >
                                    Tìm kiếm
                                </Button>
                                {(searchDate || searchUser) && (
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => { setSearchDate(""); setSearchUser(""); setLichSuDatCuocPage(1); }}
                                        sx={{ textTransform: "none", borderRadius: "8px" }}
                                    >
                                        Xóa lọc
                                    </Button>
                                )}
                            </Box>

                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                <Grid item xs={6}>
                                    <Card sx={{ background: "#e0f2fe", p: 2, textAlign: "center", borderRadius: "10px" }}>
                                        <Typography variant="body2" color="#0369a1" fontWeight={500}>Tổng cược</Typography>
                                        <Typography variant="h5" color="#0284c7" fontWeight={700}>{formatMoney(totalBetMoney)}</Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={6}>
                                    <Card sx={{ background: "#dcfce7", p: 2, textAlign: "center", borderRadius: "10px" }}>
                                        <Typography variant="body2" color="#15803d" fontWeight={500}>Tổng thắng</Typography>
                                        <Typography variant="h5" color="#16a34a" fontWeight={700}>{formatMoney(totalWinMoney)}</Typography>
                                    </Card>
                                </Grid>
                            </Grid>

                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600 }}>Tên tài khoản</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Thể loại</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Phiên</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Cửa đặt</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Tổng cược</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Tổng trả</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Thanh toán</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Ngày tạo</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredLichSuDatCuoc && filteredLichSuDatCuoc.length > 0 ? (
                                        filteredLichSuDatCuoc.slice((lichSuDatCuocPage - 1) * 10, lichSuDatCuocPage * 10).map((item, idx) => (
                                            <TableRow key={idx} hover>
                                                <TableCell sx={{ fontWeight: 500, color: "#2563eb" }}>{item.user?.username || item.user?.name || "Người chơi"}</TableCell>
                                                <TableCell>Baccarat 60s Bàn {sanhLetters[SANH_ID - 1]}</TableCell>
                                                <TableCell>{item.id_bet?.id_bet || item.id_bet || ""}</TableCell>
                                                <TableCell>{renderResultChip(item.state)}</TableCell>
                                                <TableCell sx={{ color: "#ef4444", fontWeight: 500 }}>{formatMoney(item.money)}</TableCell>
                                                <TableCell sx={{ color: "#10b981", fontWeight: 500 }}>{formatMoney(item.moneythang || item.winMoney || 0)}</TableCell>
                                                <TableCell sx={{ color: "#64748b" }}>{["Win", "Lose", "Cancelled"].includes(item.status_bet) ? "Đã thanh toán" : "Đang chờ"}</TableCell>
                                                <TableCell>{item.createdAt ? new Date(item.createdAt).toLocaleString("vi-VN") : ""}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={8} align="center" sx={{ py: 3, color: "#64748b", fontWeight: 400 }}>
                                                Chưa có lịch sử đặt cược nào trong hệ thống.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                <Pagination count={Math.ceil(filteredLichSuDatCuoc.length / 10) || 1} page={lichSuDatCuocPage} onChange={(e, p) => setLichSuDatCuocPage(p)} color="primary" />
                            </Box>
                        </DialogContent>
                    </Dialog>
                    <BlockchainGameGuideModal open={openGuideModal} onClose={() => setOpenGuideModal(false)} />
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SetBaccarat60s;
